import React from "react";
import "./Pagination.scss";

interface Props {
  currentPage: number;
  totalPage: number;
  setPageNumber?: React.Dispatch<React.SetStateAction<number>>;
}

const Pagination: React.FC<Props> = ({
  currentPage,
  totalPage,
  setPageNumber,
}) => {
  const setPageNumberFunc = (value: number) => {
    if (value <= totalPage && value > 0 && setPageNumber != undefined) {
      setPageNumber(value);
    }
  };

  return (
    <div className="pagination-parent">
      {totalPage > 0 ? (
        <>
          <div
            key={totalPage + 3}
            style={{
              borderTopLeftRadius: "20px",
              borderBottomLeftRadius: "20px",
            }}
            className="pagination-arrow"
            onClick={() => setPageNumberFunc(currentPage - 1)}
          >
            «
          </div>
          {totalPage === 1 ? (
            <div
              key={1}
              className={`pagination-number ${
                currentPage === 1 ? `current-page` : ``
              }`}
            >
              1
            </div>
          ) : totalPage === 2 ? (
            <>
              <div
                key={1}
                onClick={() => setPageNumberFunc(1)}
                className={`pagination-number ${
                  currentPage === 1 ? `current-page` : ``
                }`}
              >
                1
              </div>
              <div
                key={2}
                onClick={() => setPageNumberFunc(2)}
                className={`pagination-number ${
                  currentPage === 2 ? `current-page` : ``
                }`}
              >
                2
              </div>
            </>
          ) : totalPage === 3 ? (
            <>
              <div
                key={1}
                onClick={() => setPageNumberFunc(1)}
                className={`pagination-number ${
                  currentPage === 1 ? `current-page` : ``
                }`}
              >
                1
              </div>
              <div
                key={2}
                onClick={() => setPageNumberFunc(2)}
                className={`pagination-number ${
                  currentPage === 2 ? `current-page` : ``
                }`}
              >
                2
              </div>
              <div
                key={3}
                onClick={() => setPageNumberFunc(3)}
                className={`pagination-number ${
                  currentPage === 3 ? `current-page` : ``
                }`}
              >
                3
              </div>
            </>
          ) : totalPage === 4 ? (
            <>
              <div
                key={1}
                onClick={() => setPageNumberFunc(1)}
                className={`pagination-number ${
                  currentPage === 1 ? `current-page` : ``
                }`}
              >
                1
              </div>
              <div
                key={2}
                onClick={() => setPageNumberFunc(2)}
                className={`pagination-number ${
                  currentPage === 2 ? `current-page` : ``
                }`}
              >
                2
              </div>
              <div
                key={3}
                onClick={() => setPageNumberFunc(3)}
                className={`pagination-number ${
                  currentPage === 3 ? `current-page` : ``
                }`}
              >
                3
              </div>
              <div
                key={4}
                onClick={() => setPageNumberFunc(4)}
                className={`pagination-number ${
                  currentPage === 4 ? `current-page` : ``
                }`}
              >
                4
              </div>
            </>
          ) : totalPage === 5 ? (
            <>
              <div
              key={1}
                onClick={() => setPageNumberFunc(1)}
                className={`pagination-number ${
                  currentPage === 1 ? `current-page` : ``
                }`}
              >
                1
              </div>
              <div
              key={2}
                onClick={() => setPageNumberFunc(2)}
                className={`pagination-number ${
                  currentPage === 2 ? `current-page` : ``
                }`}
              >
                2
              </div>
              <div
              key={3}
                onClick={() => setPageNumberFunc(3)}
                className={`pagination-number ${
                  currentPage === 3 ? `current-page` : ``
                }`}
              >
                3
              </div>
              <div
              key={4}
                onClick={() => setPageNumberFunc(4)}
                className={`pagination-number ${
                  currentPage === 4 ? `current-page` : ``
                }`}
              >
                4
              </div>
              <div
              key={5}
                onClick={() => setPageNumberFunc(5)}
                className={`pagination-number ${
                  currentPage === 5 ? `current-page` : ``
                }`}
              >
                5
              </div>
            </>
          ) : totalPage === 6 ? (
            <>
              <div
              key={1}
                onClick={() => setPageNumberFunc(1)}
                className={`pagination-number ${
                  currentPage === 1 ? `current-page` : ``
                }`}
              >
                1
              </div>
              <div
              key={2}
                onClick={() => setPageNumberFunc(2)}
                className={`pagination-number ${
                  currentPage === 2 ? `current-page` : ``
                }`}
              >
                2
              </div>
              <div
              key={3}
                onClick={() => setPageNumberFunc(3)}
                className={`pagination-number ${
                  currentPage === 3 ? `current-page` : ``
                }`}
              >
                3
              </div>
              <div
              key={4}
                onClick={() => setPageNumberFunc(4)}
                className={`pagination-number ${
                  currentPage === 4 ? `current-page` : ``
                }`}
              >
                4
              </div>
              <div
              key={5}
                onClick={() => setPageNumberFunc(5)}
                className={`pagination-number ${
                  currentPage === 5 ? `current-page` : ``
                }`}
              >
                5
              </div>
              <div
              key={6}
                onClick={() => setPageNumberFunc(6)}
                className={`pagination-number ${
                  currentPage === 6 ? `current-page` : ``
                }`}
              >
                6
              </div>
            </>
          ) : currentPage === 1 ? (
            <>
              <div
              key={1}
                onClick={() => setPageNumberFunc(1)}
                className={`pagination-number current-page`}
              >
                1
              </div>
              <div
              key={2}
                onClick={() => setPageNumberFunc(2)}
                className={`pagination-number`}
              >
                2
              </div>
              <div key={totalPage + 5} className={`pagination-number between-pages`}>...</div>
              <div
              key={totalPage - 1}
                onClick={() => setPageNumberFunc(totalPage - 1)}
                className={`pagination-number`}
              >
                {totalPage - 1}
              </div>
              <div
              key={totalPage}
                onClick={() => setPageNumberFunc(totalPage)}
                className={`pagination-number`}
              >
                {totalPage}
              </div>
            </>
          ) : currentPage === 2 ? (
            <>
              <div
              key={1}
                onClick={() => setPageNumberFunc(1)}
                className={`pagination-number`}
              >
                1
              </div>
              <div
              key={2}
                onClick={() => setPageNumberFunc(2)}
                className={`pagination-number current-page`}
              >
                2
              </div>
              <div
              key={3}
                onClick={() => setPageNumberFunc(3)}
                className={`pagination-number`}
              >
                3
              </div>
              <div key={totalPage + 5} className={`pagination-number between-pages`}>...</div>
              <div
              key={totalPage - 1}
                onClick={() => setPageNumberFunc(totalPage - 1)}
                className={`pagination-number`}
              >
                {totalPage - 1}
              </div>
              <div
              key={totalPage}
                onClick={() => setPageNumberFunc(totalPage)}
                className={`pagination-number`}
              >
                {totalPage}
              </div>
            </>
          ) : currentPage === totalPage - 1 ? (
            <>
              <div
              key={1}
                onClick={() => setPageNumberFunc(1)}
                className={`pagination-number`}
              >
                1
              </div>
              <div
              key={2}
                onClick={() => setPageNumberFunc(2)}
                className={`pagination-number`}
              >
                2
              </div>
              <div key={totalPage + 5} className={`pagination-number between-pages`}>...</div>
              <div
              key={totalPage - 2}
                onClick={() => setPageNumberFunc(totalPage - 2)}
                className={`pagination-number`}
              >
                {totalPage - 2}
              </div>
              <div
              key={totalPage - 1}
                onClick={() => setPageNumberFunc(totalPage - 1)}
                className={`pagination-number current-page`}
              >
                {totalPage - 1}
              </div>
              <div
              key={totalPage}
                onClick={() => setPageNumberFunc(totalPage)}
                className={`pagination-number`}
              >
                {totalPage}
              </div>
            </>
          ) : currentPage === totalPage ? (
            <>
              <div
              key={1}
                onClick={() => setPageNumberFunc(1)}
                className={`pagination-number`}
              >
                1
              </div>
              <div
              key={2}
                onClick={() => setPageNumberFunc(2)}
                className={`pagination-number`}
              >
                2
              </div>
              <div key={totalPage + 5} className={`pagination-number between-pages`}>...</div>
              <div
              key={totalPage - 1}
                onClick={() => setPageNumberFunc(totalPage - 1)}
                className={`pagination-number`}
              >
                {totalPage - 1}
              </div>
              <div
              key={totalPage}
                onClick={() => setPageNumberFunc(totalPage)}
                className={`pagination-number current-page`}
              >
                {totalPage}
              </div>
            </>
          ) : (
            <>
              <div
                onClick={() => setPageNumberFunc(1)}
                className={`pagination-number`}
                key={1}
              >
                1
              </div>
              {currentPage !== 3 ? (
                <div
                  key={totalPage + 1}
                  className={`pagination-number between-pages`}
                >
                  ...
                </div>
              ) : (
                <></>
              )}
              <div
                key={currentPage - 1}
                onClick={() => setPageNumberFunc(currentPage - 1)}
                className={`pagination-number`}
              >
                {currentPage - 1}
              </div>
              <div
                key={currentPage}
                onClick={() => setPageNumberFunc(currentPage)}
                className={`pagination-number current-page`}
              >
                {currentPage}
              </div>
              <div
                key={currentPage + 1}
                onClick={() => setPageNumberFunc(currentPage + 1)}
                className={`pagination-number`}
              >
                {currentPage + 1}
              </div>
              {currentPage !== totalPage - 2 ? (
                <div
                  key={totalPage + 2}
                  className={`pagination-number between-pages`}
                >
                  ...
                </div>
              ) : (
                <></>
              )}
              <div
                key={totalPage}
                onClick={() => setPageNumberFunc(totalPage)}
                className={`pagination-number`}
              >
                {totalPage}
              </div>
            </>
          )}
          <div
            key={totalPage + 4}
            style={{
              borderTopRightRadius: "20px",
              borderBottomRightRadius: "20px",
            }}
            className="pagination-arrow"
            onClick={() => setPageNumberFunc(currentPage + 1)}
          >
            »
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Pagination;
